import React, { Component } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CrackedCodeSettings = {
  dots: true,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 2.5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: true,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: true,
      },
    },
  ],
};

class SuccessfulStudent extends Component {
  render() {
    const sliderItems = [
      { id: 1, name: "- Rahul S.", location: "Now an Australian PR Holder", description: "Language Academy made NAATI CCL prep easy for me. The online format allowed me to study while working full-time. I passed within 6 weeks and earned my PR points!" },
      { id: 2, name: " – Aarti P.", location: "Now a student in Melbourne", description: "I struggled with translation accuracy, but the trainers helped me improve with personalized feedback. The mock tests were game changers!" }, 
      { id: 3, name: "- Rahul S.", location: "Now an Australian PR Holder", description: "Language Academy made NAATI CCL prep easy for me. The online format allowed me to study while working full-time. I passed within 6 weeks and earned my PR points!" },        
    ];

    return (
      <div className="cracked-section slider-dot-arrow">
        <div className="container">
          <h2
            className="primary-heading text-center"
            dangerouslySetInnerHTML={{ __html: this.props.title }}
          />
          <h3
            className="sub-title text-center fw-600 my-4"
             dangerouslySetInnerHTML={{ __html: this.props.subtitle }}
          />
        </div>
        <div className="slider-bleed-wrapper">
          <Slider {...CrackedCodeSettings} className="home-cards-slider">
            {sliderItems.map(item => (
              <div key={item.id}>
                <div className="crack-card">
                  <div className="crack-img-wrapper">
                    {/* Optional image or icon */}
                  </div>
                  <div className="crack-content">
                    <div className="user-info">
                      <div className="user-img">
                        <img src="/images/web-new-images/crack-user.png" alt={item.name} />
                      </div>
                      <div className="user-content">
                        <h3 className="user-name">{item.name}</h3>
                        <h3 className="user-location">{item.location}</h3>
                      </div>
                    </div>
                    <div className="user-discription">
                      {item.description}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    );
  }
}

export default SuccessfulStudent;
